import { useCallback } from 'react'

/**
 * Creates the loadTemplate function with all necessary dependencies
 * @param {Object} params - Object containing required state setters and API
 * @returns {Function} The loadTemplate callback function
 */
export const createLoadTemplate = ({
  setIsLoading,
  settemplate_content,
  settemplate_id,
  templateAPI,
  settemplate_category_id,
  setTemplateMetadata
}) => {
  return useCallback(async (id) => {
    try {
      setIsLoading(true)
      let response

      if (id) {
        // Load as template by ID directly
        response = await templateAPI.getById(id)

        if (response.data.success && response.data.data) {
          const tpl = response.data.data
          console.log('🔍 Template data received:', tpl)

          // Handle nested template_content structure
          let content = null

          // Check for double-nested template_content (current issue)
          if (tpl.template_content?.template_content) {
            content = tpl.template_content.template_content
            console.log('📋 Using double-nested template_content')
          }
          // Check for single-nested template_content
          else if (tpl.template_content) {
            content = tpl.template_content
            console.log('📋 Using single-nested template_content')
          }
          // Fallback to legacy fields
          else if (tpl.template_content || tpl.content) {
            content = tpl.template_content || tpl.content
            console.log('📋 Using legacy template_content/content')
          }

          // If content exists, use it as-is; otherwise build minimal default
          const formatted = content || {
            id: tpl.id,
            name: tpl.name || 'Untitled Template',
            pages: [{
              id: 'page-1',
              page_config: {
                width: tpl.width || 800,
                height: tpl.height || 600,
                backgroundColor: '#ffffff',
                name: 'Page 1'
              },
              items: []
            }]
          }

          // Ensure the template name is always set from the database record
          if (formatted && tpl.name) {
            formatted.name = tpl.name
          }

          console.log('✅ Template content formatted:', formatted)
          console.log('📝 Template name set to:', formatted.name)

          settemplate_content(formatted)
          settemplate_id(id)
          settemplate_category_id(tpl.category_id)

          // Store template metadata for access control
          setTemplateMetadata({
            id: tpl.id,
            is_public: tpl.is_public || tpl.is_public,
            is_premium: tpl.is_premium || tpl.isPremium,
            stage: tpl.stage,
            user_id: tpl.user_id,
            name: tpl.name,
            description: tpl.description
          })
        }
      } else {
        // Create new template with default content
        const defaultTemplate = {
          id: null,
          name: 'Untitled Template',
          pages: [{
            id: 'page-1',
            page_config: {
              width: 800,
              height: 600,
              backgroundColor: '#ffffff',
              name: 'Page 1'
            },
            items: []
          }]
        }
        settemplate_content(defaultTemplate)
        settemplate_id(null)
      }
    } catch (error) {
      console.error('Error loading template:', error)
      // Load default template on error
      const defaultTemplate = {
        id: null,
        name: 'Untitled Template',
        pages: [{
          id: 'page-1',
          page_config: {
            width: 800,
            height: 600,
            backgroundColor: '#ffffff',
            name: 'Page 1'
          },
          items: []
        }]
      }
      settemplate_content(defaultTemplate)
      settemplate_id(null)
    } finally {
      setIsLoading(false)
    }
  }, [setIsLoading, settemplate_content, settemplate_id, templateAPI])
}
